import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { WhitelabelId } from '@whitelabel/WhitelabelId';

export const useIsCitiWhitelabel = () => {
    const { whitelabelId } = useAppContext();
    const citiWhitelabelIds = [
        WhitelabelId.CITIUS,
        WhitelabelId.CITIUSUAT1,
        WhitelabelId.CITIUSUAT2,
        WhitelabelId.CITIUSUAT3,
    ];

    return citiWhitelabelIds.includes(whitelabelId);
};
